import { LinkProps } from "react-router-dom"
import { routes } from "../../../constants/routes"
import { roles } from "../../../constants/roles"
import { ShowFor } from "../../access/ShowFor"
import { ProfileMenuSection } from "./ProfileMenuSection"
import { EmailPreferencesTab } from "../tabs/email-preferences/EmailPreferencesContent"
import { user } from "../../../user/user"
import { useAgreement } from "../../seller-buyside/useAgreement"
import { SettlementAgreementStatus } from "../../../types/bid-as-dealer/SettlementAgreementStatus"
import { ResetErrorLink } from "../../layouts/ResetErrorLink"

interface ProfileMenuItemsProps {
    onItemClick: () => void
}

export const ProfileMenuItems = ({ onItemClick }: ProfileMenuItemsProps) => {
    const agreementState = useAgreement();

    const isBd = user.hasRoles(...roles.bd());
    const isSellerAdmin = user.hasRoles(roles.SellerAdministrator);

    return (
        <>
            <ProfileMenuSection title="Account Settings" icon="settings">
                <ProfileMenuLink
                    to={routes.profile}
                    onClick={onItemClick}
                >
                    Personal
                </ProfileMenuLink>
                <ProfileMenuLink
                    to={routes.profilePasswordSettings}
                    onClick={onItemClick}
                >
                    Password
                </ProfileMenuLink>
                <ShowFor roles={roles.getAllRolesExclude(roles.ArrangersClient)}>
                    <ProfileMenuLink
                        to={routes.profileNotificationsTab(EmailPreferencesTab.Dashboard)}
                        onClick={onItemClick}
                    >
                        Alerts Center
                    </ProfileMenuLink>
                </ShowFor>
            </ProfileMenuSection>
            <ProfileMenuSection title="Company" icon="company">
                <ProfileMenuLink
                    to={routes.profileCompanyInformation}
                    onClick={onItemClick}
                >
                    Information
                </ProfileMenuLink>
                {!isSellerAdmin &&
                    <>
                        <ShowFor roles={[...roles.bd(), ...roles.admin(), roles.DataEntry, roles.Viewer]}>
                            <ProfileMenuLink
                                to={routes.profileTraders}
                                onClick={onItemClick}
                            >
                                Platform Users
                            </ProfileMenuLink>
                        </ShowFor>
                        <ShowFor roles={[...roles.seller()]}>
                            <ProfileMenuLink
                                to={routes.profileManagePlatformUsers}
                                onClick={onItemClick}
                            >
                                Platform Users
                            </ProfileMenuLink>
                        </ShowFor>
                        <ShowFor roles={[...roles.seller(), ...roles.bd()]}>
                            {
                                !user.current()?.isClearingBank &&
                                (!isBd || agreementState.agreement?.agreementStatus === SettlementAgreementStatus.confirmed) &&
                                <ProfileMenuLink
                                    to={routes.profileTradingLimitsTab()}
                                    onClick={onItemClick}
                                >
                                    Trading Limits
                                </ProfileMenuLink>
                            }
                        </ShowFor>
                    </>
                }
                <ShowFor roles={[...roles.subscriptionChange(), roles.Administrator]}>
                    <ProfileMenuLink
                        to={routes.subscriptionsTab()}
                        onClick={onItemClick}
                    >
                        Subscription
                    </ProfileMenuLink>
                </ShowFor>
            </ProfileMenuSection>
            <ShowFor role={roles.SellerAdministrator}>
                <ProfileMenuSection title="Manage" icon="manage">
                    <ProfileMenuLink
                        to={routes.profileManagePlatformUsers}
                        onClick={onItemClick}
                    >
                        Platform Users
                    </ProfileMenuLink>
                    <ProfileMenuLink
                        to={routes.profileTradingLimitsTab()}
                        onClick={onItemClick}
                    >
                        Trading Limits
                    </ProfileMenuLink>
                    <ProfileMenuLink
                        to={routes.profileManageDealers}
                        onClick={onItemClick}
                    >
                        Counterparties
                    </ProfileMenuLink>
                </ProfileMenuSection>
            </ShowFor>
        </>
    )
}

function ProfileMenuLink(props: LinkProps) {
    return <ResetErrorLink {...props} className="navbar-dropdown-menu-item" />
}